function createQuoteParamsWin(params,LANG){
  let langKeys = {
    board_type:{1:"single piece",3:"panel by customer",2:"panel by nextpcb"}, 
    break_away_rail:{"N/A":"n/a", "Y":"left & right", "X":"top & bottom", "XY":"all 4 sides"},
    min_trace_space_outer:{10:"10/10mil↑",8:"8/8mil↑",6:"6/6mil↑",5:"5/5mil",4:"4/4mil",3.5:"3.5/3.5mil"},
    min_drilled_hole:{0.3:"0.3mm↑",0.25:"0.25mm",0.2:"0.2mm",0.15:"0.15mm"},
    cover:{'Tenting Vias':"tenting vias",'Vias Not Covered':"vias not covered",'Solder Mask Plug (IV-B)':"solder mask plug (iv-b)",'Non-Conductive Fill & Cap (VII)':"non-conductive fill & cap (vii)"},
    bankong:{0:"no",1:"half_holes_one_side"},
    baobian:{0:"no",1:"castellated_holes_one"},
    pressing:{0:"no_requirement",'Customer Specified Stack up':"customer_specified_stack_up"},
    has:{0:"no",1:"yes",2:"yes",3:"yes"},
    hdi_structure:{1:"rank_1",2:"rank_2",3:"rank_3"},
    need:{0:"don't need",1:"need_1",2:"need_1"},
    report_format:{1:"electronic",2:"paper"},
    period_format:{2:"ul_week_year",1:"ul_year_week"},
    bom_material_supply:{1:"turnkey",2:"combo",3:"kitted_consigned",4:"associated_bom_order"},
    pcb_supply:{1:"kitted_consigned",2:"nextpcb_customisation",3:"associated_pcb_order"},
    assembly_side_s:{1:"single side",2:"double side"},
    painting_conformal_coating:{0:"don't need",1:"single side",2:"double side"},
    stencil_type:{"Stencil for Solder Paste":"stencil_for_solder_paste","Stencil for Adhesives":"stencil_for_adhesives","Step Down Stencil":"step_down_stencil"},
    printing_method:{1:"semi-automatic_printing",2:"fully_automatic_printing",3:"manual_printing"},
    stencil_side:{"Top":"top","Bottom":"bottom","Combine Top Bottom":"top & bottom","Separate Top Bottom":"top & bottom ( different solder paste )"},
    existing_fiducials:{"None":"none","Half lasered":"half lasered","Lasered through":"lasered through"},
    board_breakout:{0:"grinding_and_polishing",1:"electropolishing"},
    engineering_require:{1:"nextpcb_specification",2:"confirm_by_customer"},
    cross_board:{1:"accept_cross_board",2:"not_accept_cross_board"},
    electrical_test:{
      'Sample Test Free': 'sample test free',
      'Batch Flying Probe Test': 'aoi+flying test',
      'Batch Fixture Test': 'aoi+fixture',
      'Sampling Tests': 'aoi+sampling test',
      'Visual Inspection': 'fqc visual inspections free'
    },
    stencil_size:{
      '280x380mm':"280x380mm(Valid area 190x290mm)",
      '300x400mm':"300x400mm(Valid area 140x240mm)",
      '370x470mm':"370x470mm(Valid area 190x290mm)",
      '420x520mm':"420x520mm(Valid area 240x340mm)",
      '450x550mm':"450x550mm(Valid area 270x370mm)",
      '584x584mm':"584x584mm(Valid area 380x380mm)",
      '550x650mm':"550x650mm(Valid area 350x450mm)",
      '736x736mm':"736x736mm(Valid area 500x500mm)",
      '400x600mm':"400x600mm(Valid area 220x400mm)",
      '400x800mm':"400x800mm(Valid area 220x600mm)",
      '400x1000mm':"400x1000mm(Valid area 220x760mm)",
      '400x1200mm':"400x1200mm(Valid area 220x1000mm)",
      '400x1400mm':"400x1400mm(Valid area 220x1200mm)",
      '500x700mm':"500x700mm(Valid area 320x500mm)",
      '500x1200mm':"500x1200mm(Valid area 320x600mm)",
      '500x800mm':"500x800mm(Valid area 320x1300mm)"
    }
  }
  let paramHtml = {
    pcb: `
    <h3>PCB</h3>
    <div>
      <h4>
        ${LANG.basic_info}
      </h4>
      <table>
        <tr>
          <th> ${LANG.material_type} </th> <td> ${params.plate_type} </td>
          <th> ${LANG.layer_count} </th> <td>${LANG[params.blayer+(params.blayer>1?'layers':'layer')]} </td>
        </tr>
        <tr>
          <th> ${LANG.tg} </th> <td> ${params.board_tg||'--'} </td>
          <th> ${LANG.board_type} </th> <td> ${LANG[langKeys.board_type[params.units]]} </td>
        </tr>
        <tr>
          <th> Panelization Method </th> <td> ${params.layoutx}*${params.layouty}pcs</td>
          <th> ${LANG.size}${params.units == 3 ? '(panel)' : ''}  </th> <td>${Number((params.blength*10).toFixed(1))} x ${Number((params.bwidth*10).toFixed(1))} mm</td>
        </tr>
        <tr>
          <th> ${LANG.break_away_rail} </th> <td> ${LANG[langKeys.break_away_rail[params.sidedirection]]} ${params.sidewidth?'('+params.sidewidth+'mm)':''}</td>          
          <th> ${LANG.qty} </th> <td> ${params.bcount||0}${params.units == 1?'pcs':'set'} ${(params.pcscount&&params.units != 1&&params.bcount)?'('+params.pcscount+'pcs)':''}</td>
        </tr>
        <tr> 
           <th> ${LANG.pcb_thickness} </th> <td>${params.bheight}mm</td>        
          <th> ${LANG.solder_mask_color} </th> <td> ${params.color}</td>
        </tr>
        <tr>
          <th> ${LANG.silkscreen} </th> <td>${params.charcolor}</td>        
          <th> ${LANG.electrical_test} </th> <td> ${LANG[langKeys.electrical_test[params.test]]}</td>
        </tr>
        <tr>
          <th> ${LANG.qty_of_test_points} </th> <td>${params.testpoint}</td>        
          <th> ${LANG.pbnum} </th> <td> ${params.pbnum} </td>
        </tr>
      </table>
    </div>
    <div>
      <h4>
        ${LANG.pcb_parameters}
      </h4>
      <table>
        <tr>
          <th> ${LANG.finished_copper_weight} </th> <td> ${params.copper}oz </td>
          <th> ${LANG.inner_copper_weight} </th> <td> ${params.blayer>2?params.insidecopper+'oz':'--'} </td>
        </tr>
        <tr>
          <th> ${LANG.min_trace_space_outer1} </th> <td> ${langKeys.min_trace_space_outer[params.lineweight]} </td>
          <th> ${LANG.min_drilled_hole} </th> <td> ${langKeys.min_drilled_hole[params.vias]} </td>
        </tr>
        <tr>
          <th> ${LANG.via_process} </th> <td> ${LANG[langKeys.cover[params.cover]]}</td>
          <th> ${LANG.hole_density} </th> <td> ${params.zknum}</td>
          
        </tr>
        <tr>
          <th> ${LANG.thickness_of_immersion_gold} </th> <td> ${params.cjh?params.cjh+'μ″':'--'}</td>
          <th> ${LANG.surface_finish} </th> <td>${params.spray} </td>
        </tr>	
        <tr>
          <th> ${LANG.gold_settling_area} </th> <td> ${params.cjarea}${params.cjarea.toString().includes('%')?'':'%'}</td>
          <th> &nbsp; </th> <td>&nbsp;</td>
        </tr>								
      </table>
    </div>
    <div>
      <h4>
        ${LANG.special_process}
      </h4>
      <table>
        <tr>
          <th> ${LANG['hdi(buried/blind vias)']}</th> <td> ${LANG[langKeys.has[params.blind]]} </td>
          <th> ${LANG.hdi_structure} </th> <td> ${params.blind?LANG[langKeys.hdi_structure[params.blind]]:'--'} </td>
        </tr>
        <tr>
          <th> ${LANG.impedance} </th> <td> ${LANG[langKeys.has[params.impendance]]} </td>
          <th> ${LANG.beveling_of_g_f} </th> <td> ${LANG[langKeys.need[params.beveledge]]} </td>
        </tr>
        <tr>
          <th> ${LANG.plated_half_holes_plated_through_hole1} </th> <td> ${LANG[langKeys.bankong[params.bankong||0]]}</td>
          <th> ${LANG.edge_plating} </th> <td> ${LANG[langKeys.baobian[params.baobian||0]]} </td>
        </tr>
        ${(params.blayer >=4 && params.blayer <= 20) ? ` 
        <tr>
          <th> ${LANG.laminated_structure} </th> <td> ${LANG[langKeys.pressing[params.pressing || 0]]}</td>
          <th> ${LANG.pad_width} </th> <td> ${Number(params.pad_width) ? (Number(params.pad_width) > 0.25 ? '≥0.25mm' : (params.pad_width+'mm') ) : '' } </td>
        </tr>` : `
        <tr>
          <th> ${LANG.pad_width} </th> <td> ${Number(params.pad_width) ? (Number(params.pad_width) > 0.25 ? '≥0.25mm' : (params.pad_width+'mm') ) : '' } </td>
          <th> </th> <td> </td>
        </tr>
        `}															
      </table>
    </div>	
    <div>
      <h4>
        ${LANG.personalized_service}
      </h4>
      <table>
        <tr>
          <th> ${LANG.approve_working_gerber} </th> <td> ${LANG[langKeys.need[params.review_file]]} </td>
          <th> ${LANG.delivery_report} </th> <td> ${LANG[langKeys.need[params.shipment_report]]} </td>
        </tr>
        <tr>
          <th> ${LANG.microsection_analysis_report1} </th> <td> ${LANG[langKeys.need[params.slice_report]]} </td>
          <th> ${LANG.film} </th> <td> ${LANG[langKeys.need[params.film_report || 0]]} </td>
        </tr>
        <tr>
          <th> ${LANG.report_format} </th> <td> ${params.report_type?LANG[langKeys.report_format[params.report_type]]:'--'} </td>
          <th> ${LANG.ul_mark} </th> <td> ${params.has_period==6?LANG[langKeys.period_format[params.period_format]]:LANG[langKeys.need[0]]} </td>
        </tr>	
        <tr>
          <th> ${LANG.cross_board} </th> <td> ${LANG[langKeys.cross_board[params.cross_board]]} </td>
          <th> &nbsp; </th> <td> &nbsp; </td>
        </tr>																								
      </table>
    </div>
    `,
    assembly:`
    <h3>${LANG.pcb_assembly_param}</h3>
    <div>
      <h4>
      ${LANG.pcb_assembly_param}
      </h4>
      <table>
        <tr>
          <th> ${LANG.bom_material_supply} </th> <td> ${params.buy_bom ? LANG[langKeys.bom_material_supply[params.buy_bom]] : ''} </td>
          <th> ${LANG.pcb_supply} </th> <td> ${params.custom_pcb_ban ? LANG[langKeys.pcb_supply[params.custom_pcb_ban]] : ''} </td>
        </tr>   
        <tr>
          <th> ${LANG.number_of_pcb_for_smt} </th> <td> ${params.number}pcs</td>
          <th> ${LANG.pcb_size}${params.units == 3 ? '(panel)' : ''}  </th> <td> ${Number(((params.pcb_height||params.blength || 0)*10).toFixed(1))}*${Number(((params.pcb_width||params.bwidth||0)*10).toFixed(1))}mm </td>
        </tr>
        <tr>
          <th> ${LANG.assembly_side_s} </th> <td> ${LANG[langKeys.assembly_side_s[params.single_or_double_technique]]} </td>
          <th> ${LANG.the_number_of_components} </th> <td> ${params.patch_material_type||0} </td>
        </tr> 
        <tr>
          <th> ${LANG.number_of_smd_pads} </th> <td> ${params.patch_pad_number||0} </td>
          <th> ${LANG.solder_insert_material}</th> <td> ${LANG[langKeys.has[params.is_plug]]} </td>
        </tr> 
        <tr>
          <th> ${LANG['plug-in_material_type']} </th> <td> ${params.plug_material_type||0} </td>
          <th> ${LANG['number_of_plug-in_pads']} </th> <td> ${params.plug_number||0} </td>
        </tr>
        <tr>
          <th> ${LANG.need_remove_board} </th> <td> ${LANG[langKeys.has[params.need_split]]} </td>
          <th> ${LANG.painting_conformal_coating} </th> <td> ${LANG[langKeys.painting_conformal_coating[params.need_conformal_coating]]} </td>
        </tr>
        <tr>
          <th> ${LANG['number_of_x-ray_components']} </th> <td> ${params.x_ray_number||0} </td>
          <th> ${LANG['number_of_x-ray_boards']} </th> <td> ${params.x_ray_unit_number||0} </td>
        </tr> 
        <tr>
          <th> ${LANG.functional_testing} </th> <td> ${LANG[langKeys.has[params.is_test]]} </td>
          <th> &nbsp; </th> <td> &nbsp; </td>
        </tr>  
      </table>
    </div>                      
    `,
    stencil: `
    <h3>${LANG.stencil}</h3>
    <div>
      <h4>
      ${LANG.stencil}
      </h4>
      <table>
        <tr>
          <th> ${LANG.stencil_frame} </th> <td> ${params.stencil_frame} </td>
          <th> ${LANG.stencil_type} </th> <td> ${LANG[langKeys.stencil_type[params.stencil_type]]} </td>
        </tr>   
        <tr>
          <th> ${LANG.printing_method} </th> <td> ${LANG[langKeys.printing_method[params.printing_type]]} </td>
          <th> ${LANG.size_mm}${params.units == 3 ? '(panel)' : ''}  </th> <td> ${langKeys.stencil_size[params.stencil_size]} </td>
        </tr>
        <tr>
          <th> ${LANG.stencil_side} </th> <td> ${LANG[langKeys.stencil_side[params.stencil_side]]} </td>
          <th> ${LANG.quantity} </th> <td> ${params.stencil_num}pcs</td>
        </tr> 
        <tr>
          <th> ${LANG.thickness} </th> <td> ${params.stencil_thickness}mm </td>
          <th> ${LANG.existing_fiducials} </th> <td> ${LANG[langKeys.existing_fiducials[params.existing_fiducials]]} </td>
        </tr> 
        <tr>
          <th> ${LANG.electropolishing} </th> <td> ${LANG[langKeys.board_breakout[params.elec_tropolishing]]} </td>
          <th> ${LANG.engineering_requirements} </th> <td> ${LANG[langKeys.engineering_require[params.engineering_require]]} </td>
        </tr>      
      </table>
    </div>
  `};
  let arr = params.service.split(",");
  let str = "";
  arr.forEach(v => {
    str+= paramHtml[v]
  });
  
  return str;
}
export { createQuoteParamsWin }